const base = { fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };

export const Squiggle = ({ className = "", color = "#9B3BF0", width = 6 }) => (
  <svg viewBox="0 0 200 40" className={`km-draw ${className}`} aria-hidden="true">
    <path pathLength="1" d="M4 24 C 24 4, 40 40, 60 20 S 96 4, 116 22 S 152 40, 172 18 S 192 10, 196 16" stroke={color} strokeWidth={width} {...base} />
  </svg>
);

export const Star = ({ className = "", color = "#E9D8FF" }) => (
  <svg viewBox="0 0 60 60" className={className} aria-hidden="true">
    <path d="M30 4 L35 24 L56 30 L35 36 L30 56 L25 36 L4 30 L25 24 Z" stroke={color} strokeWidth="4" {...base} />
  </svg>
);

export const Spiral = ({ className = "", color = "#DCC3FA" }) => (
  <svg viewBox="0 0 80 80" className={className} aria-hidden="true">
    <path d="M40 40 m0 -4 a4 4 0 1 1 -4 4 a10 10 0 1 1 10 10 a18 18 0 1 1 -18 -18 a26 26 0 1 1 26 26" stroke={color} strokeWidth="4" {...base} />
  </svg>
);

export const Swoosh = ({ className = "", color = "#B57AF0" }) => (
  <svg viewBox="0 0 160 90" className={`km-draw ${className}`} aria-hidden="true">
    <path pathLength="1" d="M8 70 C 40 10, 100 10, 140 50" stroke={color} strokeWidth="5" {...base} />
    <path pathLength="1" d="M124 34 L142 52 L118 58" stroke={color} strokeWidth="5" {...base} />
  </svg>
);

export const Scribble = ({ className = "", color = "#9B3BF0" }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
    <path d="M20 60 q10 -40 30 -10 t30 0 t20 20 q-30 30 -60 10 q-20 -15 10 -35 q25 -15 40 15" stroke={color} strokeWidth="4" {...base} />
  </svg>
);

export const Bubble = ({ className = "", color = "#E9D8FF" }) => (
  <svg viewBox="0 0 90 80" className={className} aria-hidden="true">
    <path d="M10 14 Q10 6 18 6 H72 Q80 6 80 14 V46 Q80 54 72 54 H34 L18 70 L22 54 H18 Q10 54 10 46 Z" stroke={color} strokeWidth="4" {...base} />
    <circle cx="30" cy="30" r="3" fill={color} />
    <circle cx="45" cy="30" r="3" fill={color} />
    <circle cx="60" cy="30" r="3" fill={color} />
  </svg>
);

export const Zigzag = ({ className = "", color = "#E9D8FF" }) => (
  <svg viewBox="0 0 120 30" className={className} aria-hidden="true">
    <polyline points="4,22 18,8 32,22 46,8 60,22 74,8 88,22 102,8 116,22" stroke={color} strokeWidth="4" {...base} />
  </svg>
);
